<template>
  <div class="line-content" style="width: 100%; margin-top: 16px;" ref="line" :id="id">

    <div class="line-content--item asd" flex v-for="(item, idx) in optionsList" :key="idx">
      <div flex v-for="(option, index) in item" :key="index" class="option-item"
        :name="index === 0 ? 'source' : 'target'"
        @click="clickOptions($event, option, idx, index === 0 ? 'left' : 'right')"
        :style="getOptionsStyle(index, option)" :class="{ isMobile: mobile }"
        :id="`${id}-${idx}-${index}-${option.title ? option.title.replace(/[^a-zA-Z0-9]/g, '') : ''}`"
        :data-title="option.title">
        <div class="select-cirle cirle-left" v-if="index !== 0 && !readonly"></div>
        <div style="margin-left: 15px;" class="questionSeq" v-if="index !== 0">{{
          index === 0 ? uppercaseStr[idx] : lowercaseStr[idx]
        }}
        </div>
        <bc-view-common placeholder="点击编辑选项" :border="false" style="flex: 1;min-width: 0;" :content="option.content"
          :fileInfo="option.fileInfo" :mobile="mobile" :isLineFile="mobile" :isLine="true"></bc-view-common>
        <div style="margin-right: 15px;" class="questionSeq" v-if="index === 0">{{
          index === 0 ? uppercaseStr[idx] : lowercaseStr[idx]
        }}
        </div>
        <div class="select-cirle cirle-right" v-if="index === 0 && !readonly"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { jsPlumb } from 'jsplumb'

const lowercaseStr = 'abcdefghijklmnopqrstuvwxyz'.split('')
const uppercaseStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')
const colors = ['rgba(240,63,36,0.55)', 'rgba(92,34,35,0.42)', 'rgba(240,124,130,0.7)', 'rgba(122,115,116,0.76)',
  'rgba(238,184,195,0.8)', 'rgba(99,7,28,0.62)', 'rgba(126,22,113,0.56)', 'rgba(46,49,124,0.68)',
  '#61649f', '#0f59a4', '#619ac3', '#c4cbcf',
  '#22a2c3', '#21373d', '#12a182', '#1a3b32',
  '#41ae3c', '#bec936', '#fed71a', '#ffa60f',
  '#4d4030', '#954416', '#363433', '#652b1c',
  '#ed3333']
export default {
  name: 'bc-line-question-answer',
  props: {
    options: {
      type: Array,
      default: () => []
    },
    readonly: {
      type: Boolean,
      default: false
    },
    answer: {
      type: Object,
      default: () => {
      }
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isAnswerx: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    options: {
      handler(val) {
        this.optionsList = val.map(i => i.map(x => ({ ...x })))
        // console.log(this.readonly, this.optionsList, 'this.optionsListthis.optionsListthis.optionsList', this.answer)

      },
      immediate: true
    },
    optionsList: {
      handler(val) {
        // this.loadLine()
      },
      immediate: true,
      deep: true
    },
    answer: {
      handler(val) {
        if (val.answerResults) {
          console.log(val, 'val.answerResultsval.answerResultsval.answerResults');

          let str = val.answerResults.split(';')
          this.selectLeft = []
          this.selectRight = []
          if (this.readonly) {
            str.forEach(i => {
              let left = i.charAt(0)
              let right = i.charAt(1)
              this.selectLeft.push(left || '')
              this.selectRight.push(right || '')
            })
          } else {
            str.forEach(i => {
              let [left, right] = i.split('')
              this.selectRight.push(right || '')
              this.selectLeft.push(left || '')
            })
          }
          // 在 readonly 模式下绘制连接线
          if (this.readonly) {
            this.$nextTick(() => {
              // console.log('watch监听进入了编辑drawConnections', this.selectLeft, this.selectRight);
              // this.instance.deleteEveryConnection();
              this.instance = jsPlumb.getInstance({
                Container: this.id,
                Connector: ['Straight', { curviness: 50 }],
                Anchors: ['Right', 'Left'],
                Endpoint: ['Dot', { radius: 6 }],
                PaintStyle: { stroke: '#409EFF', strokeWidth: 1 }, // 更改颜色和线宽
                EndpointStyle: { fill: '#409EFF' } // 更改端点颜色
              });
              this.drawConnections();
            });
          }

        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      lowercaseStr,
      uppercaseStr,
      optionsList: [],
      instance: null,
      id: '',
      colors,
      clickLeft: '',
      clickRight: '',
      selectLeft: [],
      selectRight: [],
      connections: [] // 存储连接线
    }
  },
  created() {
    this.id = 'line--' + uuidv4()
  },
  mounted() {
    // this.loadLine()
    this.$nextTick(() => {
      this.instance = jsPlumb.getInstance({
        Container: this.id,
        Connector: ['Straight', { curviness: 50 }],
        Anchors: ['Right', 'Left'],
        Endpoint: ['Dot', { radius: 6 }],
        PaintStyle: { stroke: '#409EFF', strokeWidth: 1 }, // 更改颜色和线宽
        EndpointStyle: { fill: '#409EFF' } // 更改端点颜色
      });

      // 如果是 readonly 模式且已有答案，绘制连接线
      if (this.readonly && this.answer.answerResults) {
        this.$nextTick(() => {
          this.drawConnections();
        });
      }
    });
  },
  methods: {
    getOptionsStyle(index, option) {

      if (this.readonly) {
        // this.$nextTick(() => {
        //   // console.log(this.selectLeft, this.selectRight, this.answer.answerResults, 'this.answer.answerResultsthis.answer.answerResultsthis.answer.answerResults');
        //   if (this.answer.answerSituation === '1') {


        //     if (index === 0) {
        //       if (colors[this.selectLeft.indexOf(option.title)]) {
        //         // return { background: 'colors[this.selectLeft.indexOf(option.title)]' + ' !important', border: '1px solid #70B603' }
        //         return { background: '#FAFAFA' + ' !important', border: '1px solid #70B603' }

        //       } else {
        //         return { background: '#FBFBFB' }
        //       }
        //     } else {
        //       if (colors[this.selectRight.indexOf(option.title)]) {
        //         // return { background: colors[this.selectRight.indexOf(option.title)] + ' !important', border: '1px solid #70B603' }
        //         return { background: '#FAFAFA' + ' !important', border: '1px solid #70B603' }

        //       } else {
        //         return { background: '#FBFBFB' }
        //       }
        //     }
        //   } else {

        //     if (index === 0) {
        //       if (colors[this.selectLeft.indexOf(option.title)]) {
        //         // return { background: colors[this.selectLeft.indexOf(option.title)] + ' !important', border: '1px solid #D9001B' }
        //         return { background: '#FAFAFA !important', border: '1px solid #D9001B' }

        //       } else {
        //         return { background: '#FBFBFB', border: '1px solid #D9001B' }
        //       }
        //     } else {
        //       if (colors[this.selectRight.indexOf(option.title)]) {
        //         // return { background: colors[this.selectRight.indexOf(option.title)] + ' !important', border: '1px solid #D9001B' }
        //         return { background: '#FAFAFA !important', border: '1px solid #D9001B' }

        //       } else {
        //         return { background: '#FBFBFB', border: '1px solid #D9001B' }
        //       }
        //     }
        //   }
        // });
      } else {
        if (index === 0) {
          if (colors[this.selectLeft.indexOf(option.title)]) {
            // return { background: colors[this.selectLeft.indexOf(option.title)] + ' !important' }
            return { background: '#DCEBFE' + ' !important', border: '1px solid #287CF7' }

          } else {
            return { background: '#FBFBFB' }
          }
        } else {
          if (colors[this.selectRight.indexOf(option.title)]) {
            // return { background: colors[this.selectRight.indexOf(option.title)] + ' !important' }
            return { background: '#DCEBFE' + ' !important', border: '1px solid #287CF7' }
          } else {
            return { background: '#FBFBFB' }
          }
        }
      }

    },
    clickOptions(event, options, idx, type) {
      if (this.isAnswerx) return;
      if (this.readonly) return
      if (type === 'left') {
        this.clickLeft = options.title
        let haveIndex = this.selectLeft.findIndex(i => i === options.title)
        if (haveIndex > -1) {
          this.$set(this.selectLeft, haveIndex, '')
          this.$set(this.selectRight, haveIndex, '')
        } else {
          let emptyIndex = this.selectLeft.findIndex((i => i === ''))
          if (emptyIndex > -1) {
            this.$set(this.selectLeft, emptyIndex, options.title)
          } else {
            this.selectLeft.push(options.title)
          }
        }

      } else {
        this.clickRight = options.title

        let haveIndex = this.selectRight.findIndex(i => i === options.title)
        if (haveIndex > -1) {
          this.$set(this.selectLeft, haveIndex, '')
          this.$set(this.selectRight, haveIndex, '')
        } else {
          let emptyIndex = this.selectRight.findIndex((i => i === ''))
          if (emptyIndex > -1) {
            this.$set(this.selectRight, emptyIndex, options.title)
          } else {
            this.selectRight.push(options.title)
          }
        }

      }

      let obj = {}
      let str = ''

      this.selectLeft.forEach((i, index) => {
        let iTitle = this.optionsList.find(o => o[0].title === i)

        if (iTitle && iTitle.length) {
          let right = this.selectRight[index]
          let iValue = ''
          if (right) {
            let title = this.optionsList.find(o => o[1].title === right)
            iValue = title ? title[1].title : ''
          }
          obj[iTitle[0].title] = iValue
        }

      })

      str = Object.keys(obj).map(key => `${key}${obj[key]}`).join(';')
      this.$emit('change', str)
      // 添加连接线逻辑
      this.$nextTick(() => {
        this.drawConnections();
      });
    },
    drawConnections() {
      // console.log(this.readonly, this.instance, 'drawConnections内');

      if (!this.instance) return;

      // 清除现有连接
      this.instance.deleteEveryConnection();
      // console.log(this.readonly, 'drawConnections内的readonly');

      if (this.readonly) {
        // readonly 模式下根据 answerResults 绘制连接线
        console.log('answerResults', this.answer.answerResults, this.selectLeft, this.selectRight);

        this.selectLeft.forEach((left, index) => {
          const right = this.selectRight[index];
          if (left && right) {
            const leftElement = document.querySelector(`#${this.id} [data-title="${left}"]`);
            const rightElement = document.querySelector(`#${this.id} [data-title="${right}"]`);

            if (leftElement && rightElement) {
              const leftOptionItem = leftElement.closest('.option-item');
              const rightOptionItem = rightElement.closest('.option-item');

              if (leftOptionItem && rightOptionItem) {
                const leftId = leftOptionItem.id;
                const rightId = rightOptionItem.id;

                // 判断是否为正确配对（大小写同一字母）
                const isCorrectPair = left.toLowerCase() === right.toLowerCase();
                console.log(leftOptionItem, rightOptionItem, 'rightOptionItemrightOptionItemrightOptionItem');

                if (!isCorrectPair) {
                  leftOptionItem.style.border = '1px solid #FFDCDC';
                  rightOptionItem.style.border = '1px solid #FFDCDC';
                }
                const lineColor = isCorrectPair ? '#D1F0DC' : '#FCD9D9';
                const cursorColor = isCorrectPair ? '#18B451' : '#EF4343'
                this.instance.manage(leftOptionItem);
                this.instance.manage(rightOptionItem);

                this.instance.connect({
                  source: leftId,
                  target: rightId,
                  Endpoint: ['Dot', { radius: 6 }],
                  paintStyle: { stroke: cursorColor, strokeWidth: 1 },
                  endpointStyle: { fill: cursorColor },
                  connector: 'Straight'
                });
              }
            }
          }
        });
      } else {
        // 根据选中项绘制连接线
        this.selectLeft.forEach((left, index) => {
          const right = this.selectRight[index];
          if (left && right) {
            console.log(this.id, 'thisid');

            const leftElement = document.querySelector(`#${this.id} [data-title="${left}"]`);
            const rightElement = document.querySelector(`#${this.id} [data-title="${right}"]`);

            if (leftElement && rightElement) {
              const leftId = leftElement.closest('.option-item').id;
              const rightId = rightElement.closest('.option-item').id;

              this.instance.connect({
                source: leftId,
                target: rightId,
                Endpoint: ['Dot', { radius: 6 }],
                paintStyle: { stroke: '#287CF7', strokeWidth: 1 },//连线颜色
                endpointStyle: { fill: '#287CF7' },//端点颜色
                connector: 'Straight' // 确保是直线
              });
            }
          }
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.line-content {
  width: 100%;
  position: relative;

  .line-content--item {
    flex: 1;

    ::v-deep .stem-content {
      height: 100%;
    }

    .select-cirle {
      background: #FFFFFF;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      border: 2px solid #287CF7;
    }

    .cirle-left {
      margin-left: -22px;
    }

    .cirle-right {
      margin-right: -6px;
    }
  }

  &+.line-content {
    margin-top: 10px;

  }

  //.line-content--item + .line-content--item {
  //  margin-left: 100px;
  //}
}

//.line-content--item + .line-content--item {
//}
.option-item+.option-item {
  //margin-top: 10px;
}

.create-option {
  width: 100%;
  margin-top: 10px;
  border-style: dashed !important;
}

.option-item {
  flex: 1;
  min-width: 0;
}

.option-item+.option-item {
  margin-left: 100px;
}

.option-item.isMobile+.option-item.isMobile {
  margin-left: 50px;
}

.option-item {
  margin-bottom: 10px;
  // background: #FBFBFB;
  align-items: center;
  border-radius: 6px;
  padding-left: 16px;
  border: 1px solid #eee;

  .questionSeq {
    padding: 8px 0;
  }

  ::v-deep .stem-content {
    &.no-border {
      padding: 8px 14px !important;
    }
  }
}
</style>
